import { useLazyQuery } from '@apollo/client';

import { GET_COMPONENT_DETAIL } from 'core/api/apollo/queries';

function useComponentLazy() {
  const [getComponent, { loading, data }] = useLazyQuery(GET_COMPONENT_DETAIL);

  const fetchComponent = (componentId, variantId) => {
    getComponent({ variables: { componentId, variantId } });
  };

  return { fetchComponent, loading, componentDetail: data?.getComponentDetail };
}

export default useComponentLazy;
